import { apiRequest } from "../../services/apiService";
import { CLEAR_GRAPH_DATA, GET_COMPLETION_ANALYSIS_DATA_FAIL, GET_COMPLETION_ANALYSIS_DATA_REQUEST, GET_COMPLETION_ANALYSIS_DATA_SUCCESS, GET_EXIT_ANALYSIS_DATA_FAIL, GET_EXIT_ANALYSIS_DATA_REQUEST, GET_EXIT_ANALYSIS_DATA_SUCCESS, GET_LEADS_DATA_FAIL, GET_LEADS_DATA_REQUEST, GET_LEADS_DATA_SUCCESS, GET_QUESTION_WISE_ANALYSIS_DATA_FAIL, GET_QUESTION_WISE_ANALYSIS_DATA_REQUEST, GET_QUESTION_WISE_ANALYSIS_DATA_SUCCESS, GET_SURVEYS_FAIL, GET_SURVEYS_REQUEST, GET_SURVEYS_SUCCESS, DELETE_LEAD_REQUEST,
DELETE_LEAD_SUCCESS,
DELETE_LEAD_FAIL, DELETE_BULK_LEADS_REQUEST, DELETE_BULK_LEADS_SUCCESS, DELETE_BULK_LEADS_FAIL } from "../constant";

export const getCompletionAnalysisData = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_COMPLETION_ANALYSIS_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/analytics/getCompletionAna`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_COMPLETION_ANALYSIS_DATA_SUCCESS, payload: response.data?.data && response.data?.data[0] })
        }
        else if (error) {
            dispatch({ type: GET_COMPLETION_ANALYSIS_DATA_FAIL })
        }
    }
}

export const getSurveys = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEYS_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getAllSurveys`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_SURVEYS_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_SURVEYS_FAIL })
        }
    }
}

export const getQuestionWiseAnalysisData = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_QUESTION_WISE_ANALYSIS_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/analytics/getQueWiseAna`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_QUESTION_WISE_ANALYSIS_DATA_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_QUESTION_WISE_ANALYSIS_DATA_FAIL })
        }
    }
}

export const getExitAnalysisData = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_EXIT_ANALYSIS_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/analytics/getExitAna`,
            data: data
        })
        if (response) {
            dispatch({ type: GET_EXIT_ANALYSIS_DATA_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_EXIT_ANALYSIS_DATA_FAIL })
        }
    }
}

export const getLeads = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_LEADS_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/analytics/getLeads`,
            data: data
        })
        if (response) {
            console.log('response.data?.data', response.data?.data) 
            dispatch({ type: GET_LEADS_DATA_SUCCESS, payload: response.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_LEADS_DATA_FAIL })
        }
    }
}

export const clearGraphData = () => {
    return { type: CLEAR_GRAPH_DATA }
}

export const deleteLead = (data, callback) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_LEAD_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/analytics/deleteLead`,
      data,
    });

    if (response) {
      dispatch({
        type: DELETE_LEAD_SUCCESS,
        payload: data.su_survey_submitted_id,
      });
      if (callback) callback(true);
    } else {
      dispatch({ type: DELETE_LEAD_FAIL });
      if (callback) callback(false);
    }
  };
};

export const deleteBulkLeads = (data, callback) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_BULK_LEADS_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: `/analytics/deleteBulkLeads`,
      data,
      showErrorToast: false,
    });

    if (response) {
      dispatch({
        type: DELETE_BULK_LEADS_SUCCESS,
        payload: data.lead_ids,
      });
      if (callback) callback(true);
    } else {
      dispatch({ type: DELETE_BULK_LEADS_FAIL });
      if (callback) callback(false);
    }
  };
};

